module.exports = __webpack_public_path__ + "static/media/CTLA_6-286w.b45c4df1.webp";